<template>
  <div id="base-container">
    <transition appear name="slide-fade">
      <b-row align-v="center" class="main-row">
        <b-col cols="12" md="6">
          <img src="@/assets/phoneImage.png" id="phone-image" />
          <p class="early-access-text">
            To download select your phone type below!
          </p>
          <span>
            <div class="access-icon-container small-margin-right">
              <a
                href="https://apps.apple.com/us/app/handoff-buy-rent-sell/id1643209831"
                target="”_blank”"
              >
                <img
                  class="access-icon"
                  src="@/assets/icon-apple-50.png"
                  alt=""
                />
              </a>
            </div>
            <div class="access-icon-container small-margin-left">
              <a
                href="https://play.google.com/store/apps/details?id=com.kelm.hand_off"
                target="”_blank”"
              >
                <img
                  class="access-icon"
                  src="@/assets/icon-android-50.png"
                  alt=""
                />
              </a>
            </div>
          </span>
        </b-col>
        <b-col cols="12" md="3">
          <div class="join-email-container">
            <p class="join-email-header">
              Stay informed about HandOff!
            </p>
            <p class="join-email-body">
              Stay informed about HandOff! Enter your email and receive exciting
              news, and special offers.
            </p>
          </div>
          <div v-if="!emailSubmitted" class="email-container">
            <b-form-input
              type="email"
              class="email-input"
              v-model="email"
              placeholder="Email"
            ></b-form-input>
            <b-button
              class="submit-email-button"
              variant="outline-primary"
              @click="submitEmail"
              >Submit</b-button
            >
          </div>
          <div v-else>
            Email Submitted!
          </div>
          <!-- <p v-if="userCount" class="user-count">
            {{ userCount }} people and counting!
          </p> -->
        </b-col>
        <b-col cols="12" md="3"></b-col>
      </b-row>
    </transition>
  </div>
</template>

<script>
import { db } from '../../firebase';
import axios from 'axios';

export default {
  data() {
    return {
      email: '',
      emailSubmitted: false,
      userCount: null
    };
  },
  computed: {
    name() {
      return this.$store.getters.userProfile;
    }
  },
  methods: {
    async getClientAddress() {
      return axios
        .get('https://api.ipify.org?format=json')
        .then(response => {
          return response.data.ip;
        })
        .catch(error => {
          console.error('Failed to fetch client address:', error);
        });
    },
    async submitEmail() {
      if (this.email) {
        let ip = await this.getClientAddress();
        db.collection('emails')
          .add({
            email: this.email,
            date: new Date(),
            referralSource: document.referrer ?? null,
            clientAddress: ip ?? null
          })
          .then(() => {
            // Email successfully uploaded
            db.collection('email-count')
              .doc('count')
              .get()
              .then(snapshot => {
                var value = snapshot.data()['value'];
                value = value + 1;
                db.collection('email-count')
                  .doc('count')
                  .update({ value: value });
              });

            this.emailSubmitted = true;
          })
          .catch(error => {
            // Error occurred while uploading email
            console.error('Error uploading email:', error);
          });
      }
    }
  },
  created() {},
  mounted() {
    db.collection('email-count')
      .doc('count')
      .get()
      .then(snapshot => {
        this.userCount = snapshot.data()['value'];
      })
      .catch(error => {
        console.error('Error retrieving user count:', error);
      });
  }
};
</script>

<style scoped>
#base-container {
  background-color: #ffffff;
  height: 75%;
}

#phone-image {
  width: 100%;
  height: auto;
}

.main-row {
  height: 100%;
}

.email-input {
  width: 100%;
  max-width: 304px;
  min-width: 200px;
}

.email-container {
  display: inline-flex;
}

.join-email-body {
  font-size: 18px;
  display: flex;
  margin-bottom: 1rem;
}

.join-email-header {
  font-weight: bold;
  font-size: 20px;
}

.submit-email-button {
  color: rgb(0, 160, 125);
  outline-color: rgb(0, 160, 125);
  border-color: rgb(0, 160, 125);
  margin-left: 1rem;
}

.submit-email-button:hover {
  color: #ffffff;
  background-color: rgb(0, 160, 125);
  border-color: rgb(0, 160, 125);
}

.user-count {
  margin-top: 1rem;
  font-size: 14px;
  color: #393939;
}

.early-access-text {
  font-size: 18px;
}

.access-icon {
  width: 40px;
  filter: invert(46%) sepia(68%) saturate(1977%) hue-rotate(134deg)
    brightness(84%) contrast(101%);
}

.access-icon-container:hover {
  background-color: #d1d1d1;
  cursor: pointer;
  border-radius: 50%;
}

.access-icon-container {
  width: min-content;
  padding: 5px;
  margin: auto;
  display: inline-flex;
}

.small-margin-right {
  margin-right: 2.5px;
}

.small-margin-left {
  margin-left: 2.5px;
}

.row {
  margin-right: 0px;
  margin-left: 0px;
}
</style>
